import it from './about.it.json';
import en from './about.en.json';

const aboutContent = { it, en };

export default aboutContent;
